import { render, staticRenderFns } from "./ChatbotHelp.vue?vue&type=template&id=17e4b776&scoped=true"
import script from "./ChatbotHelp.vue?vue&type=script&lang=js"
export * from "./ChatbotHelp.vue?vue&type=script&lang=js"
import style0 from "./ChatbotHelp.vue?vue&type=style&index=0&id=17e4b776&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e4b776",
  null
  
)

export default component.exports